module.exports = "#TreeStFrame {\n  background: transparent;\n}\n/*# sourceMappingURL=src/app/external/iframe/iframe.component.css.map */"